import { render, staticRenderFns } from "./wol.vue?vue&type=template&id=44497113&scoped=true&lang=pug"
import script from "./wol.vue?vue&type=script&lang=js"
export * from "./wol.vue?vue&type=script&lang=js"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=44497113&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44497113",
  null
  
)

export default component.exports